import React from 'react';

/* Icones em SVG: nao dependem da versao do Font Awesome carregada. */

const IconeImagem = ({ tamanho = 16 }) => (
  <svg
    width={tamanho}
    height={tamanho}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.7'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <rect x='3' y='4' width='18' height='16' rx='2.5' />
    <circle cx='8.5' cy='9.5' r='1.6' fill='currentColor' stroke='none' />
    <path d='M4 17l4.5-4.5a1.6 1.6 0 0 1 2.2 0L15 17' />
    <path d='M13.5 15l2-2a1.6 1.6 0 0 1 2.2 0L20 15.4' />
  </svg>
);

const IconeSeta = ({ direcao = 'left', tamanho = 16 }) => (
  <svg
    width={tamanho}
    height={tamanho}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    {direcao === 'left' ? (
      <path d='M15 5l-7 7 7 7' />
    ) : (
      <path d='M9 5l7 7-7 7' />
    )}
  </svg>
);

const IconeFechar = ({ tamanho = 16 }) => (
  <svg
    width={tamanho}
    height={tamanho}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.2'
    strokeLinecap='round'
    aria-hidden='true'
  >
    <path d='M6 6l12 12M18 6L6 18' />
  </svg>
);

/**
 * Fotos de um produto (ate 3). Aceita `fotos` como array de strings ou de
 * objetos ({url|imagem, legenda}) e completa com espacos vazios enquanto as
 * imagens nao estiverem cadastradas.
 */
export function fotosDoProduto(produto, total = 3) {
  const originais = Array.isArray(produto && produto.fotos) ? produto.fotos : [];
  const fotos = [];

  for (let i = 0; i < total; i++) {
    const foto = originais[i];
    const url =
      typeof foto === 'string' ? foto : foto && (foto.url || foto.imagem);

    fotos.push({
      url: url || null,
      legenda: (foto && foto.legenda) || `Foto ${i + 1}`,
    });
  }

  return fotos;
}

export function capaDoProduto(produto) {
  return fotosDoProduto(produto).filter((foto) => foto.url)[0] || null;
}

/** Quadrinho da foto, exibido antes do nome do produto. */
export function MiniaturaProduto({
  produto,
  tamanho = 48,
  onClick,
  esmaecida = false,
}) {
  const capa = capaDoProduto(produto);
  const comRotulo = tamanho >= 48;

  return (
    <div
      onClick={onClick}
      title='Ver fotos do produto'
      style={{
        position: 'relative',
        width: tamanho,
        height: tamanho,
        flexShrink: 0,
        borderRadius: tamanho >= 64 ? 12 : 8,
        overflow: 'hidden',
        border: '1px solid #e2e8f0',
        background: '#f8fafc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        opacity: esmaecida ? 0.6 : 1,
      }}
    >
      {capa ? (
        <img
          src={capa.url}
          alt={produto.nome}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      ) : (
        <span
          style={{
            color: '#94a3b8',
            display: 'flex',
            marginBottom: comRotulo ? (tamanho >= 64 ? 14 : 11) : 0,
          }}
        >
          <IconeImagem tamanho={tamanho >= 64 ? 24 : 18} />
        </span>
      )}

      {comRotulo ? (
        <span
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(15,23,42,.72)',
            color: '#fff',
            fontSize: tamanho >= 64 ? 9 : 8,
            fontWeight: 700,
            letterSpacing: '.03em',
            textAlign: 'center',
            padding: tamanho >= 64 ? '3px 0' : '2px 0',
          }}
        >
          VER FOTOS
        </span>
      ) : null}
    </div>
  );
}

/** Visualizador em tela cheia, com fundo escurecido e carrossel de 3 fotos. */
export class GaleriaProduto extends React.Component {
  state = { indice: 0 };

  componentDidMount() {
    document.addEventListener('keydown', this.handleTecla);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleTecla);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.produto !== this.props.produto) {
      this.setState({ indice: 0 });
    }
  }

  handleTecla = (evento) => {
    if (!this.props.produto) return;

    if (evento.key === 'Escape') this.props.onFechar();
    if (evento.key === 'ArrowRight') this.navegar(this.state.indice + 1);
    if (evento.key === 'ArrowLeft') this.navegar(this.state.indice - 1);
  };

  navegar(indice) {
    const total = fotosDoProduto(this.props.produto).length;
    this.setState({ indice: (indice + total) % total });
  }

  render() {
    const { produto, onFechar } = this.props;

    if (!produto) return null;

    const { indice } = this.state;
    const fotos = fotosDoProduto(produto);
    const foto = fotos[indice];

    const botaoSeta = {
      width: 46,
      height: 46,
      flexShrink: 0,
      borderRadius: '50%',
      border: '1px solid rgba(255,255,255,.25)',
      background: 'rgba(255,255,255,.08)',
      color: '#fff',
      fontSize: 16,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    };

    return (
      <div
        onClick={onFechar}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(8,11,15,.93)',
          zIndex: 9500,
          display: 'flex',
          flexDirection: 'column',
          padding: 24,
        }}
      >
        <div
          onClick={(evento) => evento.stopPropagation()}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 16,
            color: '#fff',
            paddingBottom: 16,
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: '.12em',
                textTransform: 'uppercase',
                color: '#94a3b8',
              }}
            >
              Fotos do produto
            </div>
            <div style={{ fontSize: 20, fontWeight: 700 }}>{produto.nome}</div>
          </div>

          <button
            type='button'
            onClick={onFechar}
            style={{ ...botaoSeta, fontSize: 18 }}
          >
            <IconeFechar tamanho={18} />
          </button>
        </div>

        <div
          onClick={(evento) => evento.stopPropagation()}
          style={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 20,
          }}
        >
          <button
            type='button'
            onClick={() => this.navegar(indice - 1)}
            style={botaoSeta}
          >
            <IconeSeta direcao='left' tamanho={18} />
          </button>

          <div
            style={{
              flex: 1,
              maxWidth: 900,
              height: '100%',
              borderRadius: 14,
              background: foto.url ? '#000' : 'rgba(255,255,255,.04)',
              border: foto.url
                ? '1px solid rgba(255,255,255,.12)'
                : '1px dashed rgba(255,255,255,.28)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            {foto.url ? (
              <img
                src={foto.url}
                alt={foto.legenda}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                  display: 'block',
                }}
              />
            ) : (
              <div style={{ textAlign: 'center', color: '#94a3b8', padding: 24 }}>
                <IconeImagem tamanho={44} />
                <div
                  style={{
                    marginTop: 14,
                    fontSize: 15,
                    fontWeight: 600,
                    color: '#cbd5e1',
                  }}
                >
                  {foto.legenda}
                </div>
                <div style={{ marginTop: 4, fontSize: 13 }}>
                  Imagem ainda não cadastrada para este produto.
                </div>
              </div>
            )}
          </div>

          <button
            type='button'
            onClick={() => this.navegar(indice + 1)}
            style={botaoSeta}
          >
            <IconeSeta direcao='right' tamanho={18} />
          </button>
        </div>

        <div
          onClick={(evento) => evento.stopPropagation()}
          style={{
            paddingTop: 18,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <div style={{ display: 'flex', gap: 10 }}>
            {fotos.map((miniatura, posicao) => (
              <div
                key={posicao}
                onClick={() => this.navegar(posicao)}
                style={{
                  width: 76,
                  height: 58,
                  borderRadius: 8,
                  cursor: 'pointer',
                  overflow: 'hidden',
                  background: 'rgba(255,255,255,.06)',
                  border:
                    posicao === indice
                      ? '2px solid #fff'
                      : '1px solid rgba(255,255,255,.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: posicao === indice ? 1 : 0.65,
                }}
              >
                {miniatura.url ? (
                  <img
                    src={miniatura.url}
                    alt={miniatura.legenda}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                ) : (
                  <span style={{ color: '#94a3b8', display: 'flex' }}>
                    <IconeImagem tamanho={18} />
                  </span>
                )}
              </div>
            ))}
          </div>

          <div style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600 }}>
            {indice + 1} de {fotos.length}
          </div>
        </div>
      </div>
    );
  }
}

export default GaleriaProduto;
